import EnvironmentVariableFactory from '../factories/EnvironmentVariableFactory';

export default class EnvironmentVariable {
    private static instance: EnvironmentVariable;

    private constructor() {}

    public static getInstance() {
        if (!this.instance) {
            this.instance = new EnvironmentVariable();
        }

        return this.instance;
    }

    public get(name: string): string {
        return EnvironmentVariableFactory.makeRepo().get(name).data ?? '';
    }
}
